<div class="tiles-column col">
  <div class="tile-box row">
    <div class="tile-status row">
      <div class = "tile-status-bar" data-cascade="fade-up">

      </div>
      <div class = "tile-status-bar-div">

      </div>
      <div class = "tile-status-bar" data-cascade="fade-up">

      </div>
    </div>
    <div class="tile-top  p-0 gray-bar">
    </div>
    <div class="tile-center  p-0">
      <div class="tile-info align-items-start flex-column  h-100">
        <div class="tile-info-title p16 w-100">
          <div class="gray-bar brandname" data-cascade="fade-up" data-cascade-delay-mobile="0" data-cascade-delay="0">
          </div>
          <div class="gray-bar mt-4 brandmodal" data-cascade="fade-up" data-cascade-delay-mobile="1"
            data-cascade-delay="1"></div>
          <!-- <div class="row mt15">
            <div class="col-5 p-0">
              <div class="gray-bar vehicle-badge " data-cascade="fade-up" data-cascade-delay-mobile="2"
                data-cascade-delay="2"></div>
            </div>
            <div class="col-6 p-0 pt-1">
              <div class="gray-bar grybar vehicle-miles mt-1" data-cascade="fade-up" data-cascade-delay-mobile="2"
                data-cascade-delay="2"></div>
            </div>
          </div> -->
          <hr class="gray-bar divline m7" data-cascade="fade-up" data-cascade-delay-mobile="3"
            data-cascade-delay="3" />
          <div style="display: flex">
            <div class="gray-bar tile-veh-make" data-cascade="fade-up">

            </div>
           <div class="tile-veh-make-div" data-cascade="fade-up">

           </div>
            <div class="gray-bar tile-veh-make" data-cascade="fade-up">

            </div>
          </div>
          

        </div>


      </div>

    </div>
  </div>
</div>